(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8863],{

/***/ 71927:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer",
      function () {
        return __webpack_require__(12526);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ event; }
/* harmony export */ });
/* unused harmony exports GA_TRACKING_ID, pageview */
var GA_TRACKING_ID = (/* unused pure expression or super */ null && ("G-11BQSE72VC"));
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
var pageview = function(url) {
    window.gtag("config", GA_TRACKING_ID, {
        page_path: url
    });
};
// log specific events happening.
var event = function(param) {
    var action = param.action, params = param.params;
    window.gtag("event", action, params);
};


/***/ }),

/***/ 12526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap-time-picker/dist/bundle.js
var bundle = __webpack_require__(32574);
var bundle_default = /*#__PURE__*/__webpack_require__.n(bundle);
;// CONCATENATED MODULE: ./components/client/ClientSessionReadOnly.tsx






var ClientSessionReadOnly = function(props) {
    var getDaySessions = function getDaySessions(day) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row py-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-weight-bold text-info",
                            children: day.name
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row py-1 session",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12",
                        children: day.sessions && day.sessions.map(function(session) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex my-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((bundle_default()), {
                                            value: session.startTime,
                                            disabled: true,
                                            className: "bg-white border-white"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            className: "align-self-center",
                                            children: "to"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((bundle_default()), {
                                            value: session.endTime,
                                            disabled: true,
                                            className: "bg-white border-white text-right"
                                        }),
                                        "\xa0"
                                    ]
                                })
                            });
                        })
                    })
                })
            ]
        });
    };
    var ref = (0,react.useState)([]), sessionDetails = ref[0], setSessionDetails = ref[1];
    (0,react.useEffect)(function() {
        if (props.cookieQr) {
            axios_default().get("/api/backend/client/config/fetch/" + props.cookieQr).then(function(resp) {
                if (resp.data) {
                    setSessionDetails(JSON.parse(resp.data.sessions));
                }
            }).catch(function(err) {
                setSessionDetails([]);
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {});
        }
    }, [
        props.cookieQr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                children: sessionDetails && sessionDetails.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    className: "border-secondary p-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-secondary mb-4 text-decoration-underline",
                            children: "Timings"
                        }),
                        sessionDetails.map(function(day) {
                            return getDaySessions(day);
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 5 modules
var Modal = __webpack_require__(32321);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 7 modules
var Accordion = __webpack_require__(5607);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
;// CONCATENATED MODULE: ./components/customer/PostReviewView.tsx









var PostReviewView = function(props) {
    var postReview = function postReview() {
        axios_default().post("/api/backend/reviews/create", {
            qrCode: props.qrCode,
            reviewText: reviewGiven,
            reviewerMobile: phoneNumber,
            reviewerName: name,
            voteType: vote
        }).then(function(resp) {
            if (resp.data) {
                props.postAction();
            } else {
                setError("Thanks for review! Your review has already been captured");
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getReviews = function getReviews() {
        return reviews && reviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-4 font-weight-bold fs-4",
                    children: " Reviews"
                }),
                reviews.map(function(review) {
                    return review.reviewText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-secondary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-weight-bold d-inline-block",
                                children: review.reviewerName
                            }),
                            review.voteType == "up" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "review-view-page-icon",
                                height: "30rem",
                                width: "30rem",
                                src: "/upvote.png",
                                className: "align-self-center d-inline-block"
                            }),
                            review.voteType == "down" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "review-view-page-icon",
                                height: "30rem",
                                width: "30rem",
                                src: "/downvote.png",
                                className: "align-self-center d-inline-block"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: review.reviewText
                            })
                        ]
                    }, "review");
                })
            ]
        });
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme_customer"
    ]), 2), cookies = ref[0], setCookie = ref[1];
    var cookieName = cookies.qme_customer ? cookies.qme_customer["name"] : null;
    var cookiePhoneNumber = cookies.qme_customer ? cookies.qme_customer["phone"] : null;
    var ref1 = (0,react.useState)(null), enteredOtp = ref1[0], setEnteredOtp = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)("NO"), vote = ref3[0], setVote = ref3[1];
    var ref4 = (0,react.useState)(null), reviewGiven = ref4[0], setReviewGiven = ref4[1];
    var ref5 = (0,react.useState)(cookiePhoneNumber), phoneNumber = ref5[0], setPhoneNumber = ref5[1];
    var ref6 = (0,react.useState)(cookieName), name = ref6[0], setName = ref6[1];
    var ref7 = (0,react.useState)(false), otpGenerated = ref7[0], setOtpGenerated = ref7[1];
    var ref8 = (0,react.useState)([]), reviews = ref8[0], setReviews = ref8[1];
    var ref9 = (0,react.useState)(0), totalReviews = ref9[0], setTotalReviews = ref9[1];
    var ref10 = (0,react.useState)(0), offSet = ref10[0], setOffset = ref10[1];
    (0,react.useEffect)(function() {
        if (props.qrCode) {
            fetchReviews();
        }
    }, [
        props.qrCode
    ]);
    var fetchReviews = function() {
        axios_default().post("/api/backend/reviews/fetch/" + props.qrCode, {
            offset: offSet,
            limit: 5
        }).then(function(resp) {
            console.log(resp.data);
            if (resp.data) {
                setTotalReviews(resp.data.totalReviews);
                setOffset(function(oldOffset) {
                    return oldOffset + 5;
                });
                setReviews(function(oldReviews) {
                    return oldReviews && oldReviews.length > 0 && resp.data.reviews && resp.data.reviews.length > 0 && oldReviews[0].reviewerMobile == resp.data.reviews[0].reviewerMobile ? oldReviews : (0,_to_consumable_array/* default */.Z)(oldReviews).concat((0,_to_consumable_array/* default */.Z)(resp.data.reviews));
                });
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var handleVoteChange = function(voteChanged) {
        if (voteChanged == "UP") {
            if (vote == "UP") {
                setVote("NO");
            } else {
                setVote("UP");
            }
        }
        if (voteChanged == "DOWN") {
            if (vote == "DOWN") {
                setVote("NO");
            } else {
                setVote("DOWN");
            }
        }
    };
    var handlePost = function() {
        if (cookies.qme_customer && phoneNumber == cookiePhoneNumber && name == cookieName) {
            postReview();
        } else {
            if (!(0,utils/* validatePhoneNumber */.Y0)(phoneNumber)) {
                setError("* Please provide correct mobile number");
                return;
            } else {
                setError(null);
            }
            axios_default().post("/api/backend/user/send/otp", {
                mobile: phoneNumber,
                role: "customer"
            }).then(function(resp) {
                if (resp.data) {
                    setOtpGenerated(true);
                } else {
                    setError("* User not found. Please use registered mobile number");
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    };
    var handleValidateOtp = function() {
        axios_default().post("/api/backend/user/customer/validate/otp", {
            mobile: phoneNumber,
            otp: enteredOtp
        }).then(function(resp) {
            if (!resp.data) {
                setError("* Incorrect OTP");
                return;
            } else {
                setCookie("qme_customer", {
                    "phone": phoneNumber,
                    "name": name
                }, {
                    maxAge: 2630000
                });
                setError(null);
            }
            postReview();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                className: "",
                defaultActiveKey: "0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                    eventKey: props.isExpanded ? "0" : "1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                            children: "Post a Review"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Body */.Z.Body, {
                            children: [
                                !otpGenerated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "input-group mt-3 mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "input-group-prepend",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "input-group-text",
                                                        id: "basic-addon1",
                                                        children: "+91 -"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "tel",
                                                    placeholder: "Enter phone number",
                                                    onChange: function(e) {
                                                        return setPhoneNumber(e.target.value);
                                                    },
                                                    className: "form-control"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Enter Name",
                                            onChange: function(e) {
                                                return setName(e.target.value);
                                            },
                                            className: "form-control my-3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "#/",
                                            onClick: function(e) {
                                                return handleVoteChange("UP");
                                            },
                                            children: [
                                                vote && vote == "UP" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "review-view-page-icon",
                                                    height: "50rem",
                                                    width: "50rem",
                                                    src: "/upvote.png",
                                                    className: "align-self-center"
                                                }),
                                                (!vote || vote != "UP") && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "review-view-page-icon",
                                                    height: "50rem",
                                                    width: "50rem",
                                                    src: "/upvote_not_selected.png",
                                                    className: "align-self-center"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "#/",
                                            onClick: function(e) {
                                                return handleVoteChange("DOWN");
                                            },
                                            children: [
                                                vote && vote == "DOWN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "review-view-page-icon",
                                                    height: "50rem",
                                                    width: "50rem",
                                                    src: "/downvote.png",
                                                    className: "align-self-center"
                                                }),
                                                (!vote || vote != "DOWN") && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "review-view-page-icon",
                                                    height: "50rem",
                                                    width: "50rem",
                                                    src: "/downvote_not_selected.png",
                                                    className: "align-self-center"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            placeholder: "Write a review...",
                                            onChange: function(e) {
                                                return setReviewGiven(e.target.value);
                                            },
                                            className: "form-control my-3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btn-warning text-white",
                                            onClick: handlePost,
                                            children: " Submit"
                                        })
                                    ]
                                }),
                                otpGenerated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "py-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "tel",
                                            maxLength: 6,
                                            placeholder: "Enter OTP",
                                            onChange: function(e) {
                                                return setEnteredOtp(e.target.value);
                                            },
                                            className: "form-control my-3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: handleValidateOtp,
                                            className: "form-control btn btn-info text-white",
                                            children: " Validate OTP"
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "my-3 text-danger fs-6",
                                    children: error
                                })
                            ]
                        })
                    ]
                })
            }),
            getReviews(),
            reviews.length < totalReviews && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "text-secondary",
                        onClick: fetchReviews,
                        children: "Show more..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./lib/gtag.ts
var gtag = __webpack_require__(85657);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 9 modules
var Form = __webpack_require__(3162);
;// CONCATENATED MODULE: ./components/customer/CustomerQueuingView.tsx











var CustomerQueuingView = function(props) {
    var addToken = function addToken(uhid) {
        setLoading(true);
        axios_default().post("/api/backend/queue/qr/enqueue", {
            uhid: uhid,
            qrCode: selectedQr,
            paymentStatus: "not_paid",
            qForDate: bookingDate,
            sessionStartTime: selectedSession
        }).then(function(resp) {
            if (resp.data) {
                // capture enqueue event
                gtag/* event */.B({
                    action: "enqueue",
                    params: {
                        uhid: uhid,
                        qrCode: selectedQr,
                        entityQrCode: selectedEntityQr,
                        paymentStatus: status,
                        by: "self",
                        from: from
                    }
                });
                console.log(JSON.stringify(resp.data));
                window.location.href = window.location.origin + "/t?t=" + resp.data.id;
                setLoading(false);
                setSuccess("* Patient queued with token no " + resp.data.token + ". Enter details for queuing new patient.");
                if (props.postAction) {
                    props.postAction();
                }
            } else {
                setError("* Something went wrong. Please try again later!");
            }
        }).catch(function(err) {
            setError("* Something went wrong. Please try again later!");
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setLoading(false);
        });
    };
    var saveCustomerData = function saveCustomerData(uhid) {
        if (uhid != null) {
            axios_default().post("/api/backend/customer/data/save/" + uhid + "/" + selectedQr + "?qId=" + buildQueueId(), {
                consultDate: bookingDate,
                data: JSON.stringify(new Object({
                    data: new Object({
                        vitals: {}
                    })
                }))
            }).then(function(resp) {
                addToken(uhid);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    };
    var initiatePayment = function initiatePayment() {
        axios_default().post("/api/backend/pg/initiate/upi?entityQr=" + selectedEntityQr, {
            uhid: "QME-" + uhid,
            qrCode: selectedQr,
            paymentStatus: "paid",
            qForDate: bookingDate,
            sessionStartTime: selectedSession
        }).then(function(resp) {
            if (resp.data) {
                router.push({
                    pathname: "/payment",
                    query: {
                        order_id: resp.data
                    }
                });
            } else {
                setError("* Something went wrong. Please try again later!");
            }
        }).catch(function(err) {
            setError("* Something went wrong. Please try again later!");
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setLoading(false);
        });
    };
    var save = function save() {
        setLoading(true);
        if (uhid == null || uhid == "") {
            axios_default().post("/api/backend/customers/create", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                name: name,
                mobile: mobile
            })).then(function(resp) {
                if (paymentEnabled) {
                    initiatePayment();
                } else {
                    saveCustomerData("QME-" + uhid);
                }
            }).catch(function(err) {
                setError("* Something went wrong! Please try again in some time.");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        } else {
            if (paymentEnabled) {
                initiatePayment();
            } else {
                saveCustomerData("QME-" + uhid);
            }
        }
    };
    var buildQueueId = function buildQueueId() {
        var ISTTime = new Date(bookingDate);
        return selectedQr + "_" + ISTTime.toISOString().slice(0, 10) + "_" + selectedSession;
    };
    var getPetFormData = function getPetFormData() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formUhid",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "UHID"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "fs-7 text-nowrap align-self-center",
                                            children: "Qme -"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: uhid ? uhid : "",
                                            onChange: function(e) {
                                                return setUhid(e.target.value);
                                            },
                                            name: "uhid",
                                            type: "text",
                                            size: "sm",
                                            placeholder: "Enter UHID if Available"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formPhone",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Phone no.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: mobile ? mobile : "",
                                    onChange: function(e) {
                                        return setMobile(e.target.value);
                                    },
                                    name: "mobile",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter Phone Number"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-12 col-lg-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "mb-3",
                                controlId: "formName",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                        className: "fs-7 text-secondary",
                                        children: [
                                            "Pet Name",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-danger",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        value: name ? name : "",
                                        onChange: function(e) {
                                            return setName(e.target.value);
                                        },
                                        name: "name",
                                        type: "text",
                                        size: "sm",
                                        placeholder: "Enter Pet Name"
                                    })
                                ]
                            }),
                            options && options.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3",
                                children: options.map(function(o) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                        label: o.name,
                                        name: "options",
                                        type: "radio",
                                        checked: name == o,
                                        onChange: function() {
                                            return handleSelectPatient(o);
                                        }
                                    }, o);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formFather",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Owner's name",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["fatherName"] ? formData["fatherName"] : "",
                                    onChange: handleChange,
                                    name: "fatherName",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter Owner's name"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formPetAge",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Pet Age"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["age"] ? formData["age"] : "",
                                    onChange: handleChange,
                                    name: "age",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter pet age"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formPetGender",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Pet Gender"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["gender"] ? formData["gender"] : "",
                                    onChange: handleChange,
                                    name: "gender",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter pet gender"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    var getPatientFormData = function getPatientFormData() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formUhid",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "UHID"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "fs-7 text-nowrap align-self-center",
                                            children: "QMe -"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: uhid ? uhid : "",
                                            onChange: function(e) {
                                                return setUhid(e.target.value);
                                            },
                                            name: "uhid",
                                            type: "text",
                                            size: "sm",
                                            placeholder: "Enter UHID if Available"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formPhone",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Phone no.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: mobile ? mobile : "",
                                    onChange: function(e) {
                                        return setMobile(e.target.value);
                                    },
                                    name: "mobile",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter Phone Number"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-12 col-lg-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "mb-3",
                                controlId: "formName",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                        className: "fs-7 text-secondary",
                                        children: [
                                            "Name",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-danger",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        value: name ? name : "",
                                        onChange: function(e) {
                                            return setName(e.target.value);
                                        },
                                        name: "name",
                                        type: "text",
                                        size: "sm",
                                        placeholder: "Enter Name"
                                    })
                                ]
                            }),
                            options && options.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3",
                                children: options.map(function(o) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                        label: o.name,
                                        name: "options",
                                        type: "radio",
                                        checked: name == o,
                                        onChange: function() {
                                            return handleSelectPatient(o);
                                        }
                                    }, o);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formAge",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Age"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["age"] ? formData["age"] : "",
                                    onChange: handleChange,
                                    name: "age",
                                    type: "tel",
                                    size: "sm",
                                    placeholder: "Enter age in years"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formGender",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Gender"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                    onChange: handleChange,
                                    value: formData["gender"],
                                    name: "gender",
                                    size: "sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Male",
                                            children: "Male"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Female",
                                            children: "Female"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Transgender",
                                            children: "Transgender"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Other",
                                            children: "Other"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    var getCustomerDetails = function getCustomerDetails() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "",
                    children: [
                        !qmeActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-2 font-weight-bold text-danger",
                            children: "The doctor is not taking online appointments right now. Please try later."
                        }),
                        consultationFees > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "Consultation Fee:"
                                }),
                                " ₹ ",
                                consultationFees
                            ]
                        }),
                        opd && enableFutureDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2 pt-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "text-secondary text-nowrap align-self-center",
                                    children: "Appointment Date:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                    className: "form-control",
                                    selected: bookingDate,
                                    onChange: function(date) {
                                        return setBookingDate(date);
                                    },
                                    dateFormat: "dd/MM/yyyy",
                                    minDate: new Date(),
                                    disabled: props.selectedDate
                                })
                            ]
                        }),
                        availableSessions && availableSessions.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2 pt-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "text-secondary text-nowrap align-self-center",
                                    children: "Timings:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                    className: "form-select",
                                    value: selectedSession,
                                    onChange: function(e) {
                                        return setSelectedSession(e.target.value);
                                    },
                                    children: availableSessions.map(function(session) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                            value: session.startTime,
                                            children: [
                                                session.displayText && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: session.displayText
                                                }),
                                                !session.displayText && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        session.startTimeText,
                                                        " - ",
                                                        session.endTimeText
                                                    ]
                                                })
                                            ]
                                        }, session.startTime);
                                    })
                                })
                            ]
                        }),
                        selectedSession && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-muted fs-5 d-inline-block",
                                    children: " Patients Already In Queue:\xa0\xa0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-weight-bold fs-4 d-inline-block",
                                    children: waitingPatients
                                })
                            ]
                        }),
                        selectedCategory == "Veterinarian" && getPetFormData(),
                        selectedCategory != "Veterinarian" && getPatientFormData(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "form-control btn btn-info text-white",
                                disabled: !qmeActive || !selectedSession,
                                onClick: save,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-white",
                                    children: "Save"
                                })
                            })
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-3 text-danger fs-6",
                    children: error
                }),
                success && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-3 text-success fs-6",
                    children: success
                })
            ]
        });
    };
    var ref = (0,react.useState)(null), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(null), success = ref1[0], setSuccess = ref1[1];
    var ref2 = (0,react.useState)(null), selectedQr = ref2[0], setSelectedQr = ref2[1];
    var ref3 = (0,react.useState)(null), selectedCategory = ref3[0], setSelectedCategory = ref3[1];
    var ref4 = (0,react.useState)(null), selectedEntityQr = ref4[0], setSelectedEntityQr = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var ref6 = (0,react.useState)(), waitingPatients = ref6[0], setWaitingPatients = ref6[1];
    var ref7 = (0,react.useState)(), availableSessions = ref7[0], setAvailableSessions = ref7[1];
    var ref8 = (0,react.useState)(null), selectedSession = ref8[0], setSelectedSession = ref8[1];
    var ref9 = (0,react.useState)(), qmeActive = ref9[0], setQmeActive = ref9[1];
    var ref10 = (0,react.useState)(), enableFutureDate = ref10[0], setEnableFutureDate = ref10[1];
    var ref11 = (0,react.useState)(0.0), consultationFees = ref11[0], setConsultationFees = ref11[1];
    var ref12 = (0,react.useState)(new Date()), bookingDate = ref12[0], setBookingDate = ref12[1];
    var ref13 = (0,react.useState)(null), uhid = ref13[0], setUhid = ref13[1];
    var ref14 = (0,react.useState)({
        gender: "MALE"
    }), formData = ref14[0], updateFormData = ref14[1];
    var ref15 = (0,react.useState)(), name = ref15[0], setName = ref15[1];
    var ref16 = (0,react.useState)(), options = ref16[0], setOptions = ref16[1];
    var ref17 = (0,react.useState)(), mobile = ref17[0], setMobile = ref17[1];
    var ref18 = (0,react.useState)(false), paymentEnabled = ref18[0], setPaymentEnabled = ref18[1];
    var router = (0,next_router.useRouter)();
    var from = router.query["from"] && router.query["from"] != "null" ? router.query["from"].toString() : "scan";
    var ref19 = (0,react.useState)(false), opd = ref19[0], setOpd = ref19[1];
    (0,react.useEffect)(function() {
        // Perform localStorage action
        setOpd(localStorage.getItem("opd") == "true");
    }, []);
    (0,react.useEffect)(function() {
        if (uhid != null) {
            axios_default().get("/api/backend/customers/fetch/QME-" + uhid).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                if (resp.data == "") {
                    updateFormData({
                        gender: "MALE"
                    });
                    setName(null);
                    setMobile(null);
                } else {
                    updateFormData(resp.data);
                    setName(resp.data.name);
                    setMobile(resp.data.mobile);
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        uhid
    ]);
    (0,react.useEffect)(function() {
        if (mobile != null) {
            axios_default().get("/api/backend/customers/fetch/all/" + mobile).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                if (resp.data == "") {
                    setUhid(null);
                } else if (!uhid) {
                    setOptions(resp.data);
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        mobile
    ]);
    var handleChange = function(e) {
        setSuccess("");
        setError("");
        updateFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), // Trimming any whitespace
        (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    var handleSelectPatient = function(option) {
        setUhid(option.uhid.split("-")[1]);
        setOptions([]);
    };
    (0,react.useEffect)(function() {
        if (selectedQr) {
            axios_default().get("/api/backend/client/config/fetch/" + selectedQr).then(function(resp) {
                if (resp.data) {
                    setQmeActive(resp.data.qmeActive);
                    setEnableFutureDate(resp.data.futureAppointments);
                    setConsultationFees(resp.data.consultationFee);
                    setPaymentEnabled(resp.data.collectPayment);
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
            if (bookingDate) {
                axios_default().get("/api/backend/sessions/client/" + selectedQr + "?bookingDate=" + bookingDate.toISOString()).then(function(resp) {
                    console.log(JSON.stringify(resp.data));
                    if ((!resp.data || resp.data.length == 0) && props.selectedSession != null) {
                        //push emergency session in available session if it's coming from the parent component.
                        setAvailableSessions([
                            {
                                startTime: selectedSession,
                                displayText: "Emergency Session"
                            }
                        ]);
                    } else {
                        setAvailableSessions(resp.data);
                    }
                    if (props.selectedSession) {
                        setSelectedSession(props.selectedSession);
                    } else {
                        setSelectedSession(resp.data[0].startTime);
                    }
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,utils/* handleLogout */.hY)();
                    }
                });
            }
        }
    }, [
        selectedQr
    ]);
    (0,react.useEffect)(function() {
        if (bookingDate && selectedQr) {
            axios_default().get("/api/backend/sessions/client/" + selectedQr + "?bookingDate=" + bookingDate.toISOString()).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setAvailableSessions(resp.data);
                setSelectedSession(resp.data[0].startTime);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        bookingDate
    ]);
    (0,react.useEffect)(function() {
        if (selectedSession) {
            axios_default().get("/api/backend/user/client/profile?qrCode=" + selectedQr + "&qId=" + selectedQr + "_" + bookingDate.toISOString().slice(0, 10) + "_" + selectedSession).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setWaitingPatients(resp.data.waitingPatients);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                setLoading(false);
            });
        }
    }, [
        selectedSession
    ]);
    (0,react.useEffect)(function() {
        if (props.clientProfile) {
            setSelectedQr(props.clientProfile["qrCode"]);
            setSelectedEntityQr(props.clientProfile["entityQrCode"]);
            setSelectedCategory(props.clientProfile["category"]);
        }
        if (props.selectedDate) {
            setBookingDate(props.selectedDate);
        }
    }, [
        props.clientProfile,
        props.selectedDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12",
                children: getCustomerDetails()
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center py-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "spinner-border",
                    role: "status",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Loading..."
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/customer/CustomerView.tsx






var CustomerView = function(props) {
    var getModalForAddingToQueue = function getModalForAddingToQueue() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showQueueModal,
            onHide: handleCloseQueueModal,
            backdrop: "static",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerQueuingView, {
                            clientProfile: selectedClientProfile,
                            postAction: handleCloseQueueModal,
                            selectedSession: null,
                            selectedDate: null
                        })
                    })
                })
            ]
        });
    };
    var getModalForPostingReview = function getModalForPostingReview() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showPostReviewModal,
            onHide: handleClosePostReviewModal,
            backdrop: "static",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostReviewView, {
                            qrCode: selectedPostReviewQr,
                            postAction: handleClosePostReviewModal,
                            isExpanded: postReview
                        })
                    })
                })
            ]
        });
    };
    var getClientSummary = function getClientSummary(profile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "d-flex flex-row align-items-center gap-2 gap-lg-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        profile.image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "customer-view-page-icon",
                                    height: "100rem",
                                    width: "100rem",
                                    src: "https://qme-presrc.s3.ap-south-1.amazonaws.com/" + profile.image,
                                    className: "rounded-circle d-none d-lg-block"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "customer-view-page-icon",
                                    height: "70rem",
                                    width: "70rem",
                                    src: "https://qme-presrc.s3.ap-south-1.amazonaws.com/" + profile.image,
                                    className: "rounded-circle d-lg-none"
                                })
                            ]
                        }),
                        !profile.image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "customer-view-page-icon",
                                    height: "100rem",
                                    width: "100rem",
                                    src: "/listings/profile.png",
                                    className: "rounded-circle d-none d-lg-block"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "customer-view-page-icon",
                                    height: "70rem",
                                    width: "70rem",
                                    src: "/listings/profile.png",
                                    className: "rounded-circle d-lg-none"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fs-4 text-secondary d-inline-block py-1",
                            children: [
                                profile["clientName"],
                                "\xa0"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-6 text-secondary d-inline-block py-1",
                            children: profile["qualification"] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    "(",
                                    profile["qualification"],
                                    ")"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fs-6 text-secondary font-weight-bold py-1",
                            children: [
                                profile["category"],
                                "\xa0"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-6 text-secondary py-1",
                            children: profile["experience"] > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    profile["experience"],
                                    " years experience"
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    var ref = (0,react.useState)(null), selectedClientProfile = ref[0], setSelectedClientProfile = ref[1];
    var ref1 = (0,react.useState)(null), selectedPostReviewQr = ref1[0], setSelectedPostReviewQr = ref1[1];
    var ref2 = (0,react.useState)(false), postReview = ref2[0], setPostRevew = ref2[1];
    var ref3 = (0,react.useState)(false), showQueueModal = ref3[0], setShowQueueModal = ref3[1];
    var handleCloseQueueModal = function() {
        return setShowQueueModal(false);
    };
    var handleShowQueueModal = function(qrCode) {
        setSelectedClientProfile(props.clientProfiles.filter(function(value) {
            return value.qrCode == qrCode;
        })[0]);
        setShowQueueModal(true);
    };
    (0,react.useEffect)(function() {
        if (props.clientProfiles && props.clientProfiles.length == 1 && props.isQmeEnabled) {
            handleShowQueueModal(props.clientProfiles[0].qrCode);
        }
    }, [
        props.clientProfiles,
        props.isQmeEnabled
    ]);
    var ref4 = (0,react.useState)(false), showPostReviewModal = ref4[0], setShowPostReviewModal = ref4[1];
    var handleClosePostReviewModal = function() {
        setShowPostReviewModal(false);
    };
    var handleShowPostReviewModal = function(qrCode, postReview) {
        setSelectedPostReviewQr(qrCode);
        setPostRevew(postReview);
        setShowPostReviewModal(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row my-4",
            children: [
                props.businessName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 fs-2 text-center text-info font-weight-bold",
                            children: props.businessName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-secondary fs-6 text-center pb-2 pb-lg-4",
                            children: props.businessAddress
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            className: "py-2 py-lg-0",
                            defaultActiveKey: "0",
                            children: props.clientProfiles && props.clientProfiles.map(function(profile, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                    eventKey: index.toString(),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                            children: getClientSummary(profile)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Body */.Z.Body, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSessionReadOnly, {
                                                    cookieQr: profile["qrCode"]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex flex-row gap-1 py-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "Upvotes:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "align-self-center",
                                                            children: [
                                                                profile["upVotePercent"],
                                                                "%"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "align-self-center",
                                                            children: [
                                                                "(",
                                                                profile["upVotes"] + profile["downVotes"],
                                                                "\xa0votes)"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                profile.reviewsResponse && profile.reviewsResponse.reviews && profile.reviewsResponse.reviews.map(function(review) {
                                                    return review.reviewText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-secondary",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "font-weight-bold d-inline-block",
                                                                children: review.reviewerName
                                                            }),
                                                            review.voteType == "up" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                alt: "customer-view-page-icon",
                                                                height: "30rem",
                                                                width: "30rem",
                                                                src: "/upvote.png",
                                                                className: "align-self-center d-inline-block"
                                                            }),
                                                            review.voteType == "down" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                alt: "customer-view-page-icon",
                                                                height: "30rem",
                                                                width: "30rem",
                                                                src: "/downvote.png",
                                                                className: "align-self-center d-inline-block"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: review.reviewText
                                                            })
                                                        ]
                                                    }, "review");
                                                }),
                                                profile.reviewsResponse && profile.reviewsResponse.reviews && profile.reviewsResponse.totalReviews > profile.reviewsResponse.reviews.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: "#/",
                                                            className: "text-secondary",
                                                            onClick: function(e) {
                                                                return handleShowPostReviewModal(profile["qrCode"], false);
                                                            },
                                                            children: [
                                                                "See all ",
                                                                profile.reviewsResponse.totalReviews,
                                                                " reviews..."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex justify-content-between pt-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn btn-warning text-white",
                                                            onClick: function(e) {
                                                                return handleShowPostReviewModal(profile["qrCode"], true);
                                                            },
                                                            children: " Post Review"
                                                        }),
                                                        props.isQmeEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn btn-info text-white",
                                                            onClick: function(e) {
                                                                return handleShowQueueModal(profile["qrCode"]);
                                                            },
                                                            children: " Queue Me"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, "doctor-schedule");
                            })
                        }),
                        getModalForAddingToQueue(),
                        getModalForPostingReview()
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/customer.tsx








var Customer = function(props) {
    var router = (0,next_router.useRouter)();
    var qrCode = router.query["qr"] ? router.query["qr"].toString() : null;
    var filterq = router.query["filterq"] ? router.query["filterq"].toString() : null;
    var ref = (0,react.useState)(null), clientProfileEntities = ref[0], setClientProfileEntities = ref[1];
    var ref1 = (0,react.useState)(null), businessName = ref1[0], setBusinessName = ref1[1];
    var ref2 = (0,react.useState)(null), businessAddress = ref2[0], setBusinessAddress = ref2[1];
    var ref3 = (0,react.useState)(false), isQmeEnabled = ref3[0], setIsQmeEnabled = ref3[1];
    (0,react.useEffect)(function() {
        if (qrCode) {
            // log scan action event
            gtag/* event */.B({
                action: "qr-scan",
                params: {
                    qr_code: qrCode
                }
            });
            axios_default().get("/api/backend/entity/profile/qr/scan/" + qrCode).then(function(resp) {
                console.log(JSON.stringify(resp));
                if (!resp.data.fetched) {
                    window.location.href = window.location.origin + "/admin?qr=" + qrCode;
                } else {
                    var clientProfiles = resp.data.clientProfileEntities;
                    if (filterq) {
                        clientProfiles = clientProfiles.filter(function(value) {
                            return value.qrCode == filterq;
                        });
                    }
                    setClientProfileEntities(clientProfiles);
                    setBusinessName(resp.data.businessName);
                    setBusinessAddress(resp.data.businessAddress);
                    setIsQmeEnabled(resp.data.qmeEnabled);
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        qrCode,
        filterq
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "QMe - Book an appointment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "QMe - Book an appointment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "queue management software, opd management software, online appointment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col col-lg-8 offset-lg-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerView, {
                        clientProfiles: clientProfileEntities,
                        businessName: businessName,
                        businessAddress: businessAddress,
                        isQmeEnabled: isQmeEnabled
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var customer = (Customer);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,7847,8298,1074,9198,4268,9774,2888,179], function() { return __webpack_exec__(71927); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);